export const APP_TITLE = 'Zero'
export const DEFAULT_PAGE = 1
export const ROWS_PER_PAGE = 25

export const STORE_TENANTS_PER_PAGE = 25

export const bugsnagApiKey = process.env.REACT_APP_BUGSNAG_API_KEY || ''
